import { DialogComponent } from "@components/Dialog";
import { LoadingButton } from "@mui/lab";
import { Button, Stack, useMediaQuery, useTheme } from "@mui/material";

interface ISaveAsDraftDialogProps {
  translate: (text: string, options?: any) => string;
  isShowModal: boolean;
  showModalMethod: () => void;
  confirmNavigation: () => void;
  createDraftDocument: () => void;
  isSubmittingDraft: boolean;
}

export const SaveAsDraftDialog: React.FC<ISaveAsDraftDialogProps> = (props) => {
  const {
    translate,
    isShowModal,
    showModalMethod,
    confirmNavigation,
    createDraftDocument,
    isSubmittingDraft,
  } = props;

  const { breakpoints, palette } = useTheme();
  const fullScreen = useMediaQuery(breakpoints.down("sm"));

  return (
    <DialogComponent
      dialogTitle={translate(`save_draft_before_leaving`)}
      isShowModal={isShowModal}
      showModalMethod={showModalMethod}
      fullScreen={fullScreen}
      fullWidth={true}
      maxWidth="xs"
      isActionDialog={false}
      dialogSubTitle={translate("save_as_draft_subtitle")}
      dialogActions={
        <Stack
          direction="row"
          justifyContent="flex-end"
          alignItems="center"
          spacing={1.5}
        >
          <Button
            size="small"
            variant="contained"
            onClick={confirmNavigation}
            sx={{
              background: palette.error.dark,
              "&:hover": {
                background: palette.error.main,
              },
              color: "white",
            }}
          >
            {translate("discard")}
          </Button>
          <LoadingButton
            size="small"
            variant="contained"
            onClick={createDraftDocument}
            loading={isSubmittingDraft}
          >
            {translate("save_as_draft")}
          </LoadingButton>
        </Stack>
      }
    />
  );
};
